import { z } from 'zod';
import { claimFlexWorkerSchema } from '../platform-worker/platform-worker-service.schema';

const shiftAppliedStateSchema = z.enum(['accepted', 'denied', 'pending', 'canceled', 'obsolete']);

const workApplicationCancelationReasonSchema = z.enum([
  'unknown',
  'byFW',
  'automaticAllSpotsFilled',
  'automaticOverlappingShift',
  'automaticJobOrShiftDetailsChanged',
  'archived',
  'byOG',
  'byHQ',
  'byNotWelcomeList',
]);

const shiftApplicationSchema = z.object({
  state: shiftAppliedStateSchema,
  flexWorker: claimFlexWorkerSchema,
});

export const applicationDetailsSchema = shiftApplicationSchema.extend({
  allApplications: z.array(
    z.object({
      id: z.string(),
      hourlyRateCents: z.number().nullable(),
      hasDivergentRate: z.boolean(),
      shift: z.object({
        id: z.string(),
        timeZone: z.string(),
        utcEndDate: z.string(),
        utcStartDate: z.string(),
      }),
    })
  ),
  shiftId: z.string(),
  applicationId: z.string(),
  hourlyRateCents: z.number(),
  workedTotal: z.number().optional(),
  ratingPercentage: z.number().optional(),
  attendanceRate: z.number().optional(),
  hasDivergentRate: z.boolean(),
  cancelationReason: workApplicationCancelationReasonSchema,
  hasCandidateLevel: z.boolean(),
  hasRequiredCertificates: z.boolean(),
});
